import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Seo } from "../components/Seo";
import { Logo } from "../components/Logo";
import { AdCard } from "./Advertise";
import { Tag, ArrowRight } from "lucide-react";

const SITE_URL = "https://flexlines.store";

export default function Deals() {
    const [deals, setDeals] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get("/deals");
                setDeals(data);
            } catch { /* ignore */ }
            setLoading(false);
        })();
    }, []);

    return (
        <div className="min-h-screen bg-cream" data-testid="deals-page">
            <Seo
                title="Flex Line Deals — Exclusive Offers from Local & Online Businesses"
                description="Browse exclusive deals and offers from businesses partnered with Flex Line. Save on products and services you'll love."
                path="/deals"
                image="https://flexlines.store/og-deals.png"
            />
            <header className="border-b border-[#DDD6FE] bg-paper">
                <div className="max-w-5xl mx-auto px-4 h-16 flex items-center justify-between">
                    <Link to="/" data-testid="deals-home-link"><Logo /></Link>
                    <Link to="/" className="text-sm font-mono text-emerald-deep link-underline" data-testid="deals-back-home">
                        Get your number →
                    </Link>
                </div>
            </header>

            <main className="max-w-5xl mx-auto px-4 py-12">
                <div className="mb-10">
                    <p className="font-mono text-[11px] uppercase tracking-wider text-emerald-deep mb-2 flex items-center gap-1.5">
                        <Tag className="w-3.5 h-3.5" /> Flex Line Deals
                    </p>
                    <h1 className="font-display text-4xl sm:text-5xl font-light tracking-tight">
                        Offers from our <span className="font-serif-italic">partners.</span>
                    </h1>
                    <p className="text-zinc-600 mt-3 max-w-2xl">
                        Hand-picked deals from businesses in the Flex Line community. Run your own?{" "}
                        <Link to="/advertise" className="text-emerald-deep link-underline">List it here →</Link>
                    </p>
                </div>

                {loading ? (
                    <div className="py-20 text-center text-sm text-zinc-500">Loading deals…</div>
                ) : deals.length === 0 ? (
                    <div className="border border-[#DDD6FE] rounded-sm bg-paper p-12 text-center" data-testid="deals-empty">
                        <Tag className="w-7 h-7 mx-auto text-zinc-400 mb-3" />
                        <h3 className="font-display text-2xl">No deals yet — check back soon</h3>
                        <p className="text-zinc-600 mt-2">Are you a business? <Link to="/advertise" className="text-emerald-deep link-underline">Promote your offer here</Link>.</p>
                    </div>
                ) : (
                    <div className="grid md:grid-cols-2 gap-5" data-testid="deals-grid">
                        {deals.map((d) => <AdCard key={d.campaign_id} ad={d} />)}
                    </div>
                )}

                <div className="mt-14 border-t border-[#DDD6FE] pt-8 text-center">
                    <p className="text-zinc-600">Want your business in front of thousands of Flex Line members?</p>
                    <Link to="/advertise" data-testid="deals-cta-advertise"
                        className="inline-flex items-center gap-2 mt-3 h-10 px-5 bg-[#4C1D95] text-white rounded-sm text-sm hover:bg-[#4C1D95]/90">
                        Advertise with Flex Line <ArrowRight className="w-4 h-4" />
                    </Link>
                </div>
            </main>
        </div>
    );
}
